import moment from "moment";
import "moment/locale/es";

moment.locale("es");
const etiquetaTaxidermiaPdf = (values) => {

    let content = [];
    let piezasTotales = values?.piezas?.length || 1;

    if (values.piezas && values.piezas.length > 0 && Array.isArray(values.piezas)) {
        for (const [index, pieza] of values.piezas.entries()) {
            let agregarInicio = {}

            if (index !== 0) {
                agregarInicio.pageBreak = 'before';
            }

            if (pieza.estado === 0) continue;
            if (pieza.cantidad === pieza.cantidadVendida) continue;

            let tipoPermiso = "";
            let comienzoPermiso = "";

            if (values.tipoPermiso) {
                if (values.tipoPermiso === "SEMARNAT") {
                    tipoPermiso = "NO. AUT.";
                } else if (values.tipoPermiso === "CITES") {
                    tipoPermiso = values.tipoPermiso;
                    comienzoPermiso = "MX";
                } else if (values.tipoPermiso === "APROVECHAMMIENTO") {
                    tipoPermiso = values.tipoPermiso;
                    comienzoPermiso = "OF";
                } else {
                    tipoPermiso = values.tipoPermiso;
                }
            }

            content.push(
                {
                    ...agregarInicio,
                    table: {
                        widths: ['*'],
                        body: [
                            [
                                {
                                    text:
                                        `${values.nombreCliente}\n` +
                                        `${tipoPermiso} : ${comienzoPermiso} ${values.permisoCaza}\n` +
                                        `Fecha de ingreso: ${moment(values.fechaIngresoM).isValid() ? moment(values.fechaIngresoM).format("DD/MM/YYYY") : ""}\n` +
                                        `${values.nombreFamilia} - ${values.descripcionInsumo}` +
                                        (pieza.descripcion ? `\nDescripción: ${pieza.descripcion}` : ""),
                                    fontSize: 10,
                                    lineHeight: 1.3,
                                    alignment: 'center',
                                    bold: false,
                                    margin: [0, 5, 0, 5] // margen interno que genera altura visual
                                }
                            ]
                        ]
                    },
                    dontBreakRows: true,
                    pageBreak: 'avoid',
                    layout: 'noBorders'
                },

                // Texto y línea de corte
                {
                    text: 'CORTAR AQUÍ',
                    fontSize: 7,
                    color: '#F4B400',
                    margin: [3, 3, 0, 1]
                },
                {
                    canvas: [
                        {
                            type: 'line',
                            x1: 0,
                            y1: 0,
                            x2: 232.65,
                            y2: 0,
                            lineWidth: 0.4,
                            dash: { length: 2 },
                            lineColor: '#F4B400'
                        }
                    ]
                },

                // ZONA B
                {
                    table: {
                        widths: ['*'],
                        body: [
                            [
                                {
                                    text: values.etiqueta + " - " + (index + 1) + "/" + piezasTotales,
                                    fontSize: 14,
                                    bold: true,
                                    color: '#FFFFFF',
                                    alignment: 'center',
                                    margin: [0, 8, 0, 8] // altura efectiva
                                }
                            ]
                        ]
                    },
                    layout: {
                        fillColor: () => '#000000',
                        hLineWidth: () => 0,
                        vLineWidth: () => 0
                    },
                    margin: [0, 5, 0, 0]
                }
            )
        }
    } else {


        let tipoPermiso = "";
        let comienzoPermiso = "";

        if (values.tipoPermiso) {
            if (values.tipoPermiso === "SEMARNAT") {
                tipoPermiso = "NO. AUT.";
            } else if (values.tipoPermiso === "CITES") {
                tipoPermiso = values.tipoPermiso;
                comienzoPermiso = "MX";
            } else if (values.tipoPermiso === "APROVECHAMMIENTO") {
                tipoPermiso = values.tipoPermiso;
                comienzoPermiso = "OF";
            } else {
                tipoPermiso = values.tipoPermiso;
            }
        }

        content.push(
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text:
                                    `${values.nombreCliente}\n` +
                                    `${tipoPermiso} : ${comienzoPermiso} ${values.permisoCaza}\n` +
                                    `Fecha de ingreso: ${moment(values.fechaIngresoM).isValid() ? moment(values.fechaIngresoM).format("DD/MM/YYYY") : ""}\n` +
                                    `${values.nombreFamilia} - ${values.descripcionInsumo}`,
                                fontSize: 10,
                                lineHeight: 1.3,
                                alignment: 'center',
                                bold: false,
                                margin: [0, 5, 0, 5] // margen interno que genera altura visual
                            }
                        ]
                    ]
                },
                dontBreakRows: true,
                pageBreak: 'avoid',
                layout: 'noBorders'
            },

            // Texto y línea de corte
            {
                text: 'CORTAR AQUÍ',
                fontSize: 7,
                color: '#F4B400',
                margin: [3, 3, 0, 1]
            },
            {
                canvas: [
                    {
                        type: 'line',
                        x1: 0,
                        y1: 0,
                        x2: 232.65,
                        y2: 0,
                        lineWidth: 0.4,
                        dash: { length: 2 },
                        lineColor: '#F4B400'
                    }
                ]
            },

            // ZONA B
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: values.etiqueta + "/" + piezasTotales,
                                fontSize: 14,
                                bold: true,
                                color: '#FFFFFF',
                                alignment: 'center',
                                margin: [0, 8, 0, 8] // altura efectiva
                            }
                        ]
                    ]
                },
                layout: {
                    fillColor: () => '#000000',
                    hLineWidth: () => 0,
                    vLineWidth: () => 0
                },
                margin: [0, 5, 0, 0]
            }
        )
    }

    var dd = {
        pageSize: { width: 242.65, height: 153.07 },
        pageMargins: [5, 5, 5, 5],
        dontBreakRows: true,
        pageBreak: 'avoid',
        content: content
    };
    return dd;
};

export default etiquetaTaxidermiaPdf;
